
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.2 3.259L7.41 5H5a3.001 3.001 0 00-3 3v1.5A2.5 2.5 0 004.5 12h3.67A3.001 3.001 0 0111 10h2c1.306 0 2.418.835 2.83 2h3.67A2.5 2.5 0 0022 9.5V8a3 3 0 00-3-3h-2.41l-.79-1.741A3 3 0 0013.067 1.5h-2.136A3 3 0 008.2 3.259zm4.868.241h-2.136a1 1 0 00-.91.586L9.605 5h4.788l-.415-.914a1 1 0 00-.91-.586z"}}),_c('path',{attrs:{"d":"M8.17 14H4.5a4.481 4.481 0 01-2.098-.518c-.177-.093-.402.029-.402.228V19a3 3 0 003 3h14a3 3 0 003-3v-5.29c0-.2-.225-.321-.402-.228-.626.33-1.34.518-2.098.518h-3.67A3.001 3.001 0 0113 16h-2a3.001 3.001 0 01-2.83-2z"}}),_c('path',{attrs:{"d":"M11 12a1 1 0 100 2h2a1 1 0 100-2h-2z"}})])
          )
        }
      }
    